module.exports = __webpack_public_path__ + "mobile/img/banner1.725ba82a.png";